import { XCircle, MessageCircle, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { whatsappLink, COMPANY_NAME } from "@/lib/api";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-slate-50 grid place-items-center px-4">
      <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200 shadow-xl p-8 text-center" data-testid="payment-cancel-page">
        <XCircle className="h-16 w-16 text-slate-400 mx-auto mb-5" />
        <h1 className="font-heading font-bold text-2xl text-slate-900">Pagamento cancelado</h1>
        <p className="text-slate-500 mt-2">Seu pedido continua registrado. Você pode concluir o pagamento quando quiser ou falar com nossa equipe.</p>
        <div className="mt-6 flex flex-col gap-2.5">
          <a href={whatsappLink(`Olá! Preciso de ajuda para concluir meu pedido na ${COMPANY_NAME}.`)} target="_blank" rel="noreferrer">
            <Button className="w-full bg-emerald-600 hover:bg-emerald-700 text-white rounded-full h-12 gap-2"><MessageCircle className="h-5 w-5" /> Falar no WhatsApp</Button>
          </a>
          <a href="/"><Button variant="outline" className="w-full rounded-full h-12 gap-2"><Home className="h-4 w-4" /> Voltar ao início</Button></a>
        </div>
      </div>
    </div>
  );
}
